import { motion, AnimatePresence } from "framer-motion";

/**
 * Modal that displays during pull-to-refresh.
 * Shows the mfer zombie icon with animation and a grey background overlay.
 */
export const RefreshLoadingModal = ({ show }) => {
  return (
    <AnimatePresence>
      {show && (
        <>
          {/* Grey background overlay */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            style={{
              position: 'fixed',
              inset: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.4)',
              backdropFilter: 'blur(4px)',
              WebkitBackdropFilter: 'blur(4px)',
              zIndex: 9999,
              pointerEvents: 'none'
            }}
          />

          {/* Modal content with mfer zombie */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8, x: '-50%', y: 'calc(-50% - 20px)' }}
            animate={{ opacity: 1, scale: 1, x: '-50%', y: '-50%' }}
            exit={{ opacity: 0, scale: 0.8, x: '-50%', y: 'calc(-50% - 20px)' }}
            transition={{
              type: "spring",
              stiffness: 300,
              damping: 25
            }}
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              zIndex: 10000,
              pointerEvents: 'none'
            }}
          >
            <div style={{
              backgroundColor: 'white',
              borderRadius: '24px',
              boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
              padding: '32px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '16px',
              minWidth: '280px'
            }}>
              {/* Mfer zombie with animations */}
              <motion.div
                animate={{
                  y: [0, -10, 0],
                  rotate: [0, 5, -5, 0],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
                style={{ position: 'relative' }}
              >
                <img
                  src="/icons/logo-128x128.png"
                  alt="mfers arcade"
                  style={{
                    width: '96px',
                    height: '96px',
                    imageRendering: 'pixelated'
                  }}
                />

                {/* Pulsing glow effect */}
                <motion.div
                  animate={{
                    scale: [1, 1.2, 1],
                    opacity: [0.5, 0.8, 0.5],
                  }}
                  transition={{
                    duration: 1.5,
                    repeat: Infinity,
                    ease: "easeInOut"
                  }}
                  style={{
                    position: 'absolute',
                    inset: 0,
                    backgroundColor: 'rgba(254, 172, 100, 0.3)',
                    borderRadius: '50%',
                    filter: 'blur(20px)',
                    zIndex: -1
                  }}
                />
              </motion.div>

              {/* Loading text */}
              <motion.div
                animate={{
                  opacity: [0.7, 1, 0.7],
                }}
                transition={{
                  duration: 1.5,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
                style={{ textAlign: 'center' }}
              >
                <h3 style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  color: '#000',
                  marginBottom: '4px',
                  fontFamily: "'Sartoshi', sans-serif"
                }}>
                  Refreshing...
                </h3>
                <p style={{
                  fontSize: '14px',
                  color: '#666',
                  fontFamily: "'Sartoshi', sans-serif"
                }}>
                  Just a moment!
                </p>
              </motion.div>

              {/* Animated dots */}
              <div style={{ display: 'flex', gap: '8px' }}>
                {[0, 1, 2].map((index) => (
                  <motion.div
                    key={index}
                    animate={{
                      scale: [1, 1.3, 1],
                      opacity: [0.5, 1, 0.5],
                    }}
                    transition={{
                      duration: 1,
                      repeat: Infinity,
                      delay: index * 0.2,
                      ease: "easeInOut"
                    }}
                    style={{
                      width: '8px',
                      height: '8px',
                      backgroundColor: '#FEAC64',
                      borderRadius: '50%'
                    }}
                  />
                ))}
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};
